export let UserPrivileges;

(function (UserPrivileges) {
  UserPrivileges[UserPrivileges["WorkshopPlayer"] = 0] = "WorkshopPlayer";
  UserPrivileges[UserPrivileges["WorkshopParticipant"] = 1] = "WorkshopParticipant";
  UserPrivileges[UserPrivileges["SingleWorkshopAdmin"] = 2] = "SingleWorkshopAdmin";
  UserPrivileges[UserPrivileges["Admin"] = 3] = "Admin";
})(UserPrivileges || (UserPrivileges = {}));